export enum Permission {
  PayrollApprovalApprove = 154,
  PayrollApprovalShowAll = 3069,
  PayrollApprovalEditItems = 3126
}
